import React from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

const VideoModal = ({
  startRecording,
  stopRecording,
  setShowModal,
  previewStream,
  setVideoState,
}) => {
  useEffect(() => {
    startRecording();
  }, []);

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          {/*content*/}
          <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white text-black outline-none focus:outline-none '>
            START RECORDING...
            <VideoPreview stream={previewStream} />
            <button
              type='button'
              onClick={() => {
                setShowModal(false);
                stopRecording();
                setVideoState('cancel');
              }}
              className='px-6 py-2 rounded-lg bg-black text-white'
            >
              Cancel
            </button>
            <button
              type='button'
              onClick={() => {
                setShowModal(false);
                stopRecording();
                setVideoState('save');
              }}
              className='px-6 py-2 rounded-lg bg-slate-500 text-white'
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
    </>
  );
};

export default VideoModal;

function VideoPreview({ stream }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  if (!stream) {
    return null;
  }

  return <video id='video-view' ref={videoRef} autoPlay />;
}
